export const jwtTokenCookieName = 'jwtToken'

export const getCookie = (cookieName: string): string | undefined => {
  const cookieRow = document.cookie.split('; ').find((row) => row.startsWith(`${cookieName}=`))
  const cookie = cookieRow ? cookieRow.split('=')[1] : undefined
  return cookie
}

export const deleteCookie = (cookieName: string): void => {
  document.cookie = `${cookieName}=; path=/; max-age=0`
}
